import React from 'react';
import { usePriceConfig } from './PriceContext';
export function Footer() {
  const price = usePriceConfig();
  return <footer className="bg-leather py-12 px-4 border-t-8 border-[#8B5A2B]" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        {/* P.S. Section */}
        <div className="mb-12 max-w-4xl mx-auto" data-id="element-91">
          <div className="space-y-6 text-lg leading-relaxed" data-id="element-92">
            <p className="text-[#C8B894] font-semibold border-l-4 border-[#8B5A2B] pl-6" data-id="element-93">
              <span className="font-black text-[#E4D6B5] uppercase" data-id="element-94">P.D:</span>{' '}
              Recuerda… tienes mi Garantía 100% Libre de Riesgo e Incondicional
              de Devolución de Dinero. Estoy 110% seguro de que vas a estar más
              contento que un niño en Navidad con tus planos. Pero si por
              cualquier motivo no lo estás, no te preocupes. Tu inversión está
              garantizada.
            </p>
            <p className="text-[#C8B894] font-semibold border-l-4 border-[#8B5A2B] pl-6" data-id="element-95">
              <span className="font-black text-[#E4D6B5] uppercase" data-id="element-96">
                P.P.D:
              </span>{' '}
              ¡Esta es una OFERTA POR TIEMPO LIMITADO! No vas a tener la
              oportunidad de invertir en este paquete a este precio otra vez una
              vez que termine la oferta de lanzamiento. Los{' '}
              <span className="font-black text-[#E4D6B5]" data-id="element-97">
                {price.singlePayment}
              </span>{' '}
              no van a durar para siempre.
            </p>
          </div>
        </div>

        {/* Footer Links */}
        <div className="border-t-2 border-[#6F6F6F] pt-8 text-center" data-id="element-98">
          <p className="text-sm text-[#6F6F6F] mb-4 font-bold uppercase tracking-wider" data-id="element-99">
            © {new Date().getFullYear()} Fábrica Industrial — Todos Los
            Derechos Reservados
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-100">
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-101">
              Términos y Condiciones
            </a>
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-102">
              Política de Privacidad
            </a>
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-103">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}